import React from 'react';

const CloseIcon = (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.7071 16.7928C18.0976 17.1833 18.0976 17.8165 17.7071 18.207C17.3166 18.5975 16.6834 18.5975 16.2929 18.207L9.00005 10.9141L1.70711 18.2071C1.31658 18.5976 0.683418 18.5976 0.292893 18.2071C-0.0976311 17.8166 -0.0976311 17.1834 0.292893 16.7929L7.58583 9.49993L0.293009 2.20711C-0.0975153 1.81658 -0.0975157 1.18342 0.293009 0.792893C0.683533 0.402369 1.3167 0.402369 1.70722 0.792893L9.00005 8.08572L16.2928 0.792986C16.6833 0.402462 17.3165 0.402462 17.707 0.792986C18.0975 1.18351 18.0975 1.81668 17.707 2.2072L10.4143 9.49993L17.7071 16.7928Z"
      fill="#1F1E1E"
    />
  </svg>
);

export default CloseIcon;
